module.exports = __webpack_public_path__ + "static/media/beach_ball.2c945a9b.png";